import {
	ADVERTISEMENT_GET,
	ADVERTISEMENT_LOADING_STATUS,
	ADVERTISEMENT_CLEAR,
	TOGGLE_POST_EDIT_MODAL,
	TOGGLE_POST_DELETE_MODAL,
	SET_MY_POSTS,
	SET_TYPE_POSTS,
	SET_MY_FORUM_POSTS,
} from '@/store/advertisement/types'

const initialState = {
	isLoading: false,
	banner: null,
	isPostModalShow: false,
	isDeleteModalShow: false,
	isMyPost: false,
	isTypePost: false,
	isMyForumPost: false,
}

export const state = { ...initialState }

export default {
	[SET_MY_FORUM_POSTS]: (state, payload) => {
		state.isMyForumPost = payload
	},
	[SET_TYPE_POSTS]: (state, payload) => {
		state.isTypePost = payload
	},
	[SET_MY_POSTS]: (state, payload) => {
		state.isMyPost = payload
	},
	[TOGGLE_POST_DELETE_MODAL]: (state) => {
		state.isDeleteModalShow = !state.isDeleteModalShow
	},
	[TOGGLE_POST_EDIT_MODAL]: (state) => {
		state.isPostModalShow = !state.isPostModalShow
	},
	[ADVERTISEMENT_LOADING_STATUS]: (state, status) => {
		state.isLoading = status
	},
	[ADVERTISEMENT_GET]: (state, payload) => {
		state.banner = payload
	},
	[ADVERTISEMENT_CLEAR]: (state) => {
		state.banner = null
	},
}
